import Fancybox from '~/modules/fancybox'

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    Fancybox.bind(this.element, 'a[rel="lightbox"]')
  }
}
